import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { FadeUp, GoldLineDraw } from "@/components/motion/Reveal";

const STORIES = [
  {
    name: "Thandiwe Moyo",
    city: "Manchester → Harare",
    role: "Home Owner",
    avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&q=80",
    text: "I sent my first deposit from Manchester and watched foundations rise in Harare on my dashboard. MAVULA never once asked about my papers here — they only cared that I am Zimbabwean, and that was enough.",
    rating: 5,
  },
  {
    name: "Kagiso Dube",
    city: "London → Gaborone",
    role: "Investor",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80",
    text: "Titled property in Phakalane, secured on real land in a real community. I've had many pitches in London — this is the first one that felt like it was built by us, for us. My financial terms are confidential and set in my individual contract.",
    rating: 5,
  },
  {
    name: "Fatima Nyathi",
    city: "Melbourne → Lusaka",
    role: "Home Owner",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=80",
    text: "My mother lives in Kabwe. When I told her the title deed would be in her name once fully paid, she cried. That is the door MAVULA opens.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-white border-y mv-hairline" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-14">
          <FadeUp><div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Stories</span></div></FadeUp>
          <FadeUp delay={0.05}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[54px] leading-[1.02] mv-green-text mt-3">
              Real doors. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Real homes. Real people.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="mt-4 text-[15px]" style={{ color: "var(--mv-muted)" }}>
              A few of the many MAVULA members already building their future back home.
            </p>
          </FadeUp>
          <FadeUp delay={0.15}><GoldLineDraw className="mt-5 w-14" /></FadeUp>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {STORIES.map((s, i) => (
            <FadeUp key={s.name} delay={i * 0.08}>
              <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.35 }} className="mv-card p-6 md:p-7 h-full flex flex-col">
                <Quote size={32} style={{ color: "var(--mv-gold)" }} className="opacity-40" />
                <p className="mt-4 font-accent text-lg leading-relaxed" style={{ color: "var(--mv-text)" }}>
                  "{s.text}"
                </p>
                <div className="mt-6 flex items-center gap-3 pt-5 border-t mv-hairline">
                  <img src={s.avatar} alt={s.name} loading="lazy" className="w-11 h-11 rounded-full object-cover" />
                  <div className="flex-1">
                    <div className="font-semibold mv-green-text text-[14.5px]">{s.name}</div>
                    <div className="text-[12px]" style={{ color: "var(--mv-muted)" }}>{s.role} · {s.city}</div>
                  </div>
                  <div className="flex gap-0.5">
                    {Array.from({ length: s.rating }).map((_, k) => (
                      <Star key={k} size={12} fill="var(--mv-gold)" style={{ color: "var(--mv-gold)" }} />
                    ))}
                  </div>
                </div>
              </motion.div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
